import React from 'react';
import { View, Text } from 'react-native';
// config
import * as GBus from '../../../defines/GBus';
import * as GBusHelper from '../../../defines/GBusHelper';
import * as JsUtil from '../../../utils/JsUtil';
import { Colors, Layouts } from '../../../defines/Theme';
import CommonStyle from '../../../styles/CommonStyle';
import SectionStyle from '../../../styles/SectionStyle';
import TextStyle from '../../../styles/TextStyle';
import SpacerH from '../common/SpacerH'; 

//BusPlateBox
const PlateTypeBox = ({bus, style, lines}) => {

    let label = lines<2 ? GBus.GetBusTypeLabel(JsUtil.GText(bus, 'lowPlate')).replace(' ', '\n') : GBus.GetBusTypeLabel(JsUtil.GText(bus, 'lowPlate'))
    if (!label) {
        return null;
    }
    return (
        <View style={ SectionStyle("plateTypeBoxBg", style) }>
            {global.foreignLanguage=='E' ? 
            <Text style={TextStyle('rowDetail', 'smallest') }>{label}</Text>
             :
            <Text style={TextStyle('rowDetail', 'medium') }>{label}</Text>}   
        </View>
    )
}

export default PlateTypeBox